import React from 'react';
import { Label } from 'reactstrap';
import { useSelector } from 'react-redux';


const Top_input = ({ selected_params , onchange_selected_input_param }) => {
  const { params_list } = useSelector((state)=> state.WorkFlowBuilder)
  return (
    <>
        <Label className='cus-font'>Take Input from </Label>
        <select onChange={onchange_selected_input_param} className='form-select'>
          <option selected={'previous' === selected_params}  value={'previous'}>{'previous'}</option>
            {
              params_list.map((ele,index)=>{
                return <option selected={ele === selected_params} key={index} value={ele}>{ele}</option>
              })
            }
            
        </select>
    </>
  )
}

export default Top_input